/* eslint-disable prettier/prettier */
export const SignInView = () => import(/* webpackChunkName: "auth-module" */ "@/views/auth/signin.vue");
export const RecoverView = () => import(/* webpackChunkName: "auth-module" */ "@/views/auth/recover.vue");